import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './UserMenu.scss';

const propTypes = {
    name: PropTypes.string,
    role: PropTypes.string,
    trainingStat: PropTypes.bool,
    agreementStat: PropTypes.string,
    resellerAgreementStat: PropTypes.string,
};


export default class UserMenu extends React.Component{
    constructor (props) {
        super(props);
    }

    render() {
        const{name, role, trainingStat}=this.props;

        return(
            <div id="menu" className="col-md-2">
                <div className="menu_section">
                    <div className="profile">
                        <div className="profile_info">
                            <br/>
                            <span className="welcome-span">Welcome</span>
                            <br/>
                            <br/>
                            <h2>{name}</h2>
                        </div>
                    </div>
                    <div id="sidebar-menu" className="main_menu_side hidden-print main_menu active">
                        {this.props.role === 'user'  ?
                            <ul className="nav side-menu">
                                <li className="current-page">
                                    {this.props.resellerAgreementStat === 'unsigned' ?
                                        <NavLink to="/user/dashboard" className='disabled' disabled={true}><i className="ion-ios-home"></i> Home</NavLink>:
                                        <NavLink to="/user/dashboard"><i className="ion-ios-home"></i> Home</NavLink>
                                    }
                                </li>
                                <li>
                                    {this.props.resellerAgreementStat === 'unsigned' ?
                                        <NavLink to="/user/profile" className='disabled' disabled={true}><i className="ion-ios-person"></i>Profile</NavLink>:
                                        <NavLink to="/user/profile"><i className="ion-ios-person"></i>Profile</NavLink>
                                    }
                                </li>
                                <li>
                                    {this.props.resellerAgreementStat === 'unsigned' ?
                                        <NavLink to="/user/training" className='disabled' disabled={true}><i className="ion-ios-book"></i> Training</NavLink>:
                                        <NavLink to="/user/training"><i className="ion-ios-book"></i>Training</NavLink>
                                    }
                                </li>
                                <li>
                                    {this.props.resellerAgreementStat === 'unsigned' ?
                                        <NavLink to="/user/where-to-buy" className='disabled' disabled={true}><i className="ion-ios-pricetag"></i> Where To Buy</NavLink>:
                                        <NavLink to="/user/where-to-buy"><i className="ion-ios-pricetag"></i> Where To Buy</NavLink>
                                    }
                                </li>
                                <li>
                                    {this.props.resellerAgreementStat === 'unsigned' ?
                                        <NavLink to="/user/support" className='disabled' disabled={true}><i className="ion-ios-gear"></i>Support</NavLink>:
                                        <div className='support-item-div'>
                                            {this.props.trainingStat === false ?
                                                <NavLink to="/user/support" className='disabled' disabled={true}><i className="ion-ios-gear"></i>Support</NavLink> :
                                                <NavLink to="/user/support"><i className="ion-ios-gear"></i>Support</NavLink>
                                            }
                                        </div>
                                    }
                                </li>
                                <li>
                                    {this.props.resellerAgreementStat === 'unsigned' ?
                                        <a href="https://www.noonhome.com/blog/" target="_blank" className='disabled' disabled={true}><i className="ion-ios-chatboxes"></i>Blog</a>:
                                        <a href="https://www.noonhome.com/blog/" target="_blank"><i className="ion-ios-chatboxes"></i>Blog</a>
                                    }
                                </li>
                                <li>
                                    {this.props.resellerAgreementStat === 'unsigned' ?
                                        <NavLink to="/user/employees" className='disabled' disabled={true}><i className="ion-ios-people"></i>Employees</NavLink>:
                                        <NavLink to="/user/employees"><i className="ion-ios-people"></i>Employees</NavLink>
                                    }
                                </li>
                            </ul> : null
                        }
                        {this.props.role === 'electrician' ?
                            <ul className="nav side-menu">
                                <li className="current-page">
                                    <NavLink to="/user/dashboard"><i className="ion-ios-home"></i> Home</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/user/profile"><i className="ion-ios-person"></i>Profile</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/user/training"><i className="ion-ios-book"></i> Training</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/user/where-to-buy"><i className="ion-ios-pricetag"></i> Where To
                                        Buy</NavLink>
                                </li>
                                <li>
                                    {this.props.trainingStat === false ?
                                        <NavLink to="/user/support" className='disabled' disabled={true}><i className="ion-ios-gear"></i>Support</NavLink> :
                                        <NavLink to="/user/support"><i className="ion-ios-gear"></i>Support</NavLink>
                                    }
                                </li>
                                <li>
                                    <a href="https://www.noonhome.com/blog/" target="_blank"><i
                                        className="ion-ios-chatboxes"></i>Blog</a>
                                </li>
                                <li>
                                    <NavLink to="/user/employees"><i className="ion-ios-people"></i>Employees</NavLink>
                                </li>

                            </ul> : null
                        }
                        {this.props.role === 'installer'?
                            <ul className="nav side-menu">
                                <li className="current-page">
                                    <NavLink to="/user/dashboard"><i className="ion-ios-home"></i> Home</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/user/profile"><i className="ion-ios-person"></i>Profile</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/user/training"><i className="ion-ios-book"></i> Training</NavLink>
                                </li>

                                <li>
                                    <NavLink to="/user/where-to-buy"><i className="ion-ios-pricetag"></i> Where To
                                        Buy</NavLink>
                                </li>
                                <li>
                                    {this.props.trainingStat === false ?
                                        <NavLink to="/user/support" className='disabled' disabled={true}><i className="ion-ios-gear"></i>Support</NavLink> :
                                        <NavLink to="/user/support"><i className="ion-ios-gear"></i>Support</NavLink>
                                    }
                                </li>
                                <li>
                                    <a href="https://www.noonhome.com/blog/" target="_blank"><i
                                        className="ion-ios-chatboxes"></i>Blog</a>
                                </li>

                            </ul> : null
                        }

                        {this.props.role === 'distributor' ?
                            <ul className="nav side-menu">
                                <li className="current-page">
                                    {this.props.agreementStat === 'unsigned' ?
                                        <NavLink to="/user/dashboard" className='disabled' disabled={true}><i className="ion-ios-home"></i> Home</NavLink>:
                                        <NavLink to="/user/dashboard"><i className="ion-ios-home"></i> Home</NavLink>
                                    }
                                </li>
                                <li>
                                    {this.props.agreementStat === 'unsigned' ?
                                        <NavLink to="/user/profile" className='disabled' disabled={true}><i className="ion-ios-person"></i>Profile</NavLink>:
                                        <NavLink to="/user/profile"><i className="ion-ios-person"></i>Profile</NavLink>
                                    }
                                </li>
                                <li>
                                    {this.props.agreementStat === 'unsigned' ?
                                        <NavLink to="/user/training" className='disabled' disabled={true}><i className="ion-ios-book"></i> Training</NavLink>:
                                        <NavLink to="/user/training"><i className="ion-ios-book"></i>Training</NavLink>
                                    }
                                </li>
                                <li>
                                    {this.props.agreementStat === 'unsigned' ?
                                        <NavLink to="/user/support" className='disabled' disabled={true}><i className="ion-ios-gear"></i>Support</NavLink>:
                                        <div className='support-item-div'>
                                            {this.props.trainingStat === false ?
                                                <NavLink to="/user/support" className='disabled' disabled={true}><i className="ion-ios-gear"></i>Support</NavLink> :
                                                <NavLink to="/user/support"><i className="ion-ios-gear"></i>Support</NavLink>
                                            }
                                        </div>
                                    }
                                </li>
                                <li>
                                    {this.props.agreementStat === 'unsigned' ?
                                        <a href="https://www.noonhome.com/blog/" target="_blank" className='disabled' disabled={true}><i className="ion-ios-chatboxes"></i>Blog</a>:
                                        <a href="https://www.noonhome.com/blog/" target="_blank"><i className="ion-ios-chatboxes"></i>Blog</a>
                                    }
                                </li>
                                <li>
                                    {this.props.agreementStat === 'unsigned' ?
                                        <NavLink to="/user/employees" className='disabled' disabled={true}><i className="ion-ios-people"></i>Employees</NavLink>:
                                        <NavLink to="/user/employees"><i className="ion-ios-people"></i>Employees</NavLink>
                                    }
                                </li>
                                <li>
                                    {this.props.agreementStat === 'unsigned' ?
                                        <NavLink to="/user/locations" className='disabled' disabled={true}><i className="ion-ios-location"></i>Locations</NavLink>:
                                        <NavLink to="/user/locations"><i className="ion-ios-location"></i>Locations</NavLink>
                                    }
                                </li>
                            </ul> : null
                        }
                        {this.props.role === 'developer' || this.props.role === 'architect' ?
                            <ul className="nav side-menu">
                                <li className="current-page">
                                    <NavLink to="/user/dashboard"><i className="ion-ios-home"></i> Home</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/user/profile"><i className="ion-ios-person"></i>Profile</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/user/training"><i className="ion-ios-book"></i> Training</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/user/where-to-buy"><i className="ion-ios-pricetag"></i> Where To Buy</NavLink>
                                </li>
                                <li>
                                    {this.props.trainingStat === false ?
                                        <NavLink to="/user/support" className='disabled' disabled={true}><i className="ion-ios-gear"></i>Support</NavLink> :
                                        <NavLink to="/user/support"><i className="ion-ios-gear"></i>Support</NavLink>
                                    }
                                </li>
                                <li>
                                    <a href="https://www.noonhome.com/blog/" target="_blank"><i className="ion-ios-chatboxes"></i>Blog</a>
                                </li>
                            </ul> : null
                        }
                    </div>
                    <div className="sidebar-footer nav side-menu">
                        <li><a href="https://www.noonhome.com/legal/" target="_blank"><i className="ion-ios-information"></i>Legal</a></li>
                    </div>
                </div>
            </div>

        );
    }
};

UserMenu.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/Templates/User/Menu/index.js